import type { ReactNode } from 'react';
import { Breadcrumb } from './Breadcrumb';
import { useDocumentTitle } from '../../lib/useDocumentTitle';

/**
 * Mockup `.page-header`: breadcrumb + 32px/900 title (ls -0.02em) + 15px
 * gray subtitle on the left, an actions slot on the right, baseline-aligned.
 */
export function PageHeader({
  breadcrumb,
  title,
  subtitle,
  actions,
}: {
  breadcrumb?: string[];
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}): JSX.Element {
  // ADM-36: document.title acompanha o <h1> desta página (Comerciante e Staff).
  useDocumentTitle(title);
  return (
    <div className="mb-6 flex items-end justify-between gap-6">
      <div className="min-w-0">
        {breadcrumb && breadcrumb.length > 0 && <Breadcrumb items={breadcrumb} />}
        <h1 className="m-0 mb-1 text-[32px] font-black leading-tight tracking-[-0.02em] text-[var(--m-fg)]">
          {title}
        </h1>
        {subtitle && <p className="m-0 text-[15px] text-[var(--m-fg-muted)]">{subtitle}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
